module.exports = __webpack_public_path__ + "bd79e297f72c0325a634de8e14973531.pdf";